import CriteriaOverview, { type CriterionWithRating } from '@/components/ui/CriteriaOverview'
import Badge from '@/components/ui/Badge'

import { App } from '@/payload-types'

type RatingProps = {
  app: Pick<
    App,
    | 'id'
    | 'name'
    | 'slug'
    | 'icon'
    | 'glyph'
    | 'brandBackgroundColor'
    | 'brandPrimaryColor'
    | 'homepageImage'
    | 'categoryRecommendations'
  >
  efficiencyPoints: { points: number; total: number }
  criteriaWithRatings: CriterionWithRating[]
  verticalAlign?: 'top' | 'center' | 'bottom'
  horizontalAlign?: 'left' | 'center' | 'right'
}

export default function Rating({
  app,
  efficiencyPoints,
  criteriaWithRatings,
  verticalAlign = 'center',
  horizontalAlign = 'right',
}: RatingProps) {
  const allCriteriaRated =
    criteriaWithRatings.length > 0 &&
    criteriaWithRatings.every(
      (c) => c.isApplicable === false || (c.rating !== null && c.rating !== undefined),
    )
  if (!allCriteriaRated) return null

  return (
    <CriteriaOverview
      app={app}
      criteria={criteriaWithRatings}
      verticalAlign={verticalAlign}
      horizontalAlign={horizontalAlign}
      hideDescription={true}
    >
      {(isVisible) => (
        <Badge
          style={isVisible ? 'primary' : 'outline'}
          icon="gauge"
          count={efficiencyPoints.points}
        />
      )}
    </CriteriaOverview>
  )
}
